// eslint-disable-next-line import/prefer-default-export
export const STEPS = {
  personal: 0,
  practice: 1,
  profilePicture: 2,
  id: 3,
  hpcsa: 4,
}
